// accountCopy.ts — words the signed-out account surfaces share, so a refusal
// reads the same on sign-in, sign-up and recovery.

export const RATE_LIMITED = 'Too many attempts. Try again later.';
export const UNREACHABLE = 'The forge could not be reached. Try again.';
export const INVITE_ONLY =
  'JeRyū is invite-only for now. Join the waitlist and we will send an invitation when there is room.';
